export default __webpack_public_path__ + "e974f4d3ded9e21627fe3d9d74f5f482.svg";